var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3341_45078)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3341_45078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6878 10.8226L24.7161 2.1225C23.3365 1.12037 21.7052 0.590088 19.9975 0.590088C18.2898 0.590088 16.6586 1.12037 15.2789 2.1225L3.31175 10.8226C0.489591 12.8719 -0.683311 16.4759 0.395219 19.7924L4.96999 33.8673C6.04852 37.1837 9.11334 39.4127 12.6006 39.4127H27.3989C30.8862 39.4127 33.9555 37.1837 35.0295 33.8673L39.6043 19.7924C40.6828 16.4759 39.5099 12.8719 36.6878 10.8182V10.8226Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6009 38.0645C9.69781 38.0645 7.14528 36.2085 6.251 33.4493L1.67623 19.3745C0.777459 16.6152 1.75263 13.6133 4.10293 11.9101L16.0746 3.21449C17.2206 2.37863 18.5777 1.93823 19.9978 1.93823C21.4178 1.93823 22.775 2.37863 23.9209 3.21449L35.8926 11.9146C38.2384 13.6178 39.2136 16.6197 38.3193 19.379L33.7445 33.4538C32.8503 36.213 30.2977 38.069 27.3947 38.069H12.6009V38.0645Z",
    fill: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0024 2.61232C21.2427 2.61232 22.4785 2.9943 23.5301 3.75826L35.5017 12.4584C37.6049 13.9863 38.4857 16.6961 37.6813 19.1678L33.1065 33.2426C32.3021 35.7142 29.9967 37.3904 27.3993 37.3904H12.6009C9.99899 37.3904 7.69363 35.7142 6.89372 33.2426L2.31896 19.1678C1.51455 16.6961 2.39535 13.9863 4.49849 12.4584L16.4702 3.75826C17.5217 2.9943 18.7621 2.61232 19.9979 2.61232M19.9979 1.26416C18.434 1.26416 16.942 1.7495 15.6793 2.66625L3.70757 11.3664C1.12359 13.2448 0.0495497 16.5478 1.0382 19.5857L5.61297 33.6605C6.60162 36.6984 9.41029 38.7386 12.6054 38.7386H27.4038C30.5989 38.7386 33.4076 36.6984 34.3962 33.6605L38.971 19.5857C39.9597 16.5478 38.8856 13.2448 36.3017 11.3664L24.321 2.66625C23.0582 1.7495 21.5617 1.26416 20.0024 1.26416H19.9979Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.49811 15.2985L16.4698 6.59837C18.5729 5.07046 21.422 5.07046 23.5252 6.59837L35.4969 15.2985C36.6743 16.1569 37.4697 17.3837 37.7977 18.7318C38.3729 16.3815 37.4742 13.8964 35.4969 12.4539L23.5297 3.75824C21.4265 2.23033 18.5774 2.23033 16.4743 3.75824L4.49811 12.4584C2.51631 13.8964 1.62202 16.386 2.19724 18.7363C2.52529 17.3882 3.32071 16.1613 4.49811 15.303V15.2985Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38.8226,
    fill: "white",
    transform: "translate(0 0.590088)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/Experience.18ba420c642e075c8063c158ec67125c.svg";
export { ForwardRef as ReactComponent };